import currency from "currency.js";
import { useCallback } from "react";
import { getOptionAssets, getVaultChain, } from "../constants/constants";
import { useLatestOption } from "../hooks/useLatestOption";
import useLoadingText from "../hooks/useLoadingText";
import { formatOptionStrike } from "../utils/math";
import { useAssetsPrice } from "./useAssetPrice";
var useStrikePrice = function (vaultOption, vaultVersion) {
    var loadingText = useLoadingText();
    var currentOption = useLatestOption(vaultOption, vaultVersion).option;
    var prices = useAssetsPrice().prices;
    var optionAsset = getOptionAssets(vaultOption);
    var strikePrice = useCallback(function (formatted) {
        if (formatted === void 0) { formatted = true; }
        var chain = getVaultChain(vaultOption);
        if (!currentOption)
            return "---";
        if (currentOption.loading)
            return loadingText;
        if (formatted) {
            return currency(formatOptionStrike(currentOption.strike, chain)).format();
        }
        else {
            return formatOptionStrike(currentOption.strike, chain);
        }
    }, [currentOption, loadingText, vaultOption]);
    var currentPrice = useCallback(function (formatted) {
        if (formatted === void 0) { formatted = true; }
        if (prices[optionAsset].loading)
            return loadingText;
        if (formatted) {
            return currency(prices[optionAsset].price).format();
        }
        else {
            return Number(prices[optionAsset].price.toFixed(2));
        }
    }, [loadingText, optionAsset, prices]);
    return {
        strikePrice: strikePrice,
        currentPrice: currentPrice,
        isLoading: (currentOption === null || currentOption === void 0 ? void 0 : currentOption.loading) || prices[optionAsset].loading,
    };
};
export default useStrikePrice;
//# sourceMappingURL=useStrikePrice.js.map